export default {
  'monthlyStatement.title': '下载月结单',
  'monthlyStatement.period': '报表年份',
  'monthlyStatement.service': '服务类型',
  'monthlyStatement.column.month': '月份',
  'monthlyStatement.column.action': '查看或下载',
  'monthlyStatement.generatingPDF': '正在生成PDF',
  'monthlyStatement.relatedContracts': '餐厅相关合约：',
  'monthlyStatement.detecting': '检测中...',
  'monthlyStatement.reportUngenerated': '所选月份月结单暂未生成，请联系客服。',
  'monthlyStatement.generated': '已生成',
  'monthlyStatement.ungenerated': '未生成',
  'monthlyStatement4ClosedRestaurants.title': '已关闭餐厅下载月结单',
  'monthlyStatement4ClosedRestaurants.restaurantId': '餐厅id',
  'monthlyStatement4ClosedRestaurants.restaurantId.placeholder': '请输入餐厅id, 按enter键结束',
};
